import React from 'react';
import '../assets/welcome/css/game.css';

import Lottie from 'lottie-react';
import welcomeAnimation from '../assets/lottie/welcome.json';

function Welcome() {
  return (
    <div className="game-holder">
      <div className="header">
        <h1>Selamat Datang</h1>
        <h2>WORK ORDER SYSTEMS</h2>
      </div>

      <div className="world">
        <Lottie animationData={welcomeAnimation} loop={true} />
      </div>
    </div>
  );
}

export default Welcome;
